exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#qualityTaskForm[data-v-2ce10157] .el-tabs__content{height:calc(100% - 51px)}#qualityTaskForm .close[data-v-2ce10157]{float:right;font-size:20px;cursor:pointer}#qualityTaskForm .table-height[data-v-2ce10157]{height:calc(100% - 125px)}#qualityTaskForm[data-v-2ce10157] .cell-center{display:table-cell;vertical-align:inherit}[data-v-2ce10157] .is--disabled.vxe-cell--checkbox .vxe-checkbox--icon:before{background-color:#9e9e9e}", ""]);

// exports
